
import { MarkAsSeenModalOptions } from '@/components/mark-as-seen/MarkAsSeen';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

const MarkAsSeenModalGraphql = () => import('@/components/mark-as-seen/MarkAsSeenModalContainerGraphql.vue');

import { ModalHelper } from '@/helpers/modal-helper';

import { Backdrop, ObjectType } from '@/@types/graphql-types';
import TitleWatchlistMutationMixin from '@/mixins/title-quick-action-mutations/TitleWatchlistMutationMixin.vue';

@Component({
	name: 'TitlePosterRibbonGraphql',
})
export default class TitlePosterRibbonGraphql extends Mixins(TitleWatchlistMutationMixin) {
	@Prop({ required: true }) titleId: string;
	@Prop({ required: true }) titleObjectType: ObjectType;
	@Prop({ required: true }) titleObjectId: number;
	@Prop({ default: false }) isInWatchlist: boolean;
	@Prop({ default: true }) isTitleReleased: boolean;
	@Prop({ default: '' }) titleName: string;
	@Prop({ default: '' }) posterUrl: string;
	@Prop({ default: () => [] }) backdrops: Pick<Backdrop, 'backdropUrl'>[];
	@Prop({ type: String }) clickSource: string | 'similartitles';
	@Prop({ default: null }) seenEpisodeCount?: number; // Available only for Show
	@Prop({ default: 'left' }) position: 'left' | 'right';

	@Watch('isLoggedIn', { immediate: true })
	onIsLoggedInChange() {
		const titleDetails = {
			title: this.titleName,
			objectType: this.titleObjectType,
			objectId: this.titleObjectId,
		};

		if (this.isLoggedIn())
			this.mixin_onIsLoggedInChange(
				this.titleId,
				titleDetails,
				this.isInWatchlist,
				this.isInWatchlist ? 'quick-actions-2nd-bubble' : 'quick-actions'
			);
	}

	async toggleInWatchList(isInWatchlist: boolean) {
		if (!isInWatchlist) this.$emit('watchListClicked');
		const source = isInWatchlist ? 'quick-actions-2nd-bubble' : 'quick-actions';

		const trackingPayload = {
			source,
			property: this.clickSource,
		};

		const titleDetails = {
			title: this.titleName,
			objectType: this.titleObjectType,
			objectId: this.titleObjectId,
		};

		const updatedTitle = await this.mixin_setInWatchlist(
			this.titleId,
			isInWatchlist,
			titleDetails,
			trackingPayload
		);

		if (updatedTitle) {
			const isInWatchlistUpdated = !!updatedTitle.data?.setInWatchlist.title.watchlistEntry?.createdAt;

			if (
				isInWatchlistUpdated &&
				(this.titleObjectType === ObjectType.Show || this.titleObjectType === ObjectType.ShowSeason) &&
				this.isTitleReleased
			) {
				await ModalHelper.openModal(
					MarkAsSeenModalGraphql,
					{
						titleId: this.titleId,
						titleObjectType: this.titleObjectType,
						titleObjectId: this.titleObjectId,
						titleName: this.titleName,
						seenEpisodeCount: this.seenEpisodeCount,
						posterUrl: this.posterUrl,
						backdrops: this.backdrops,
					},
					MarkAsSeenModalOptions
				);
			}
		}
	}
}
